import { Stack, Typography, Button } from "@material-ui/core";
import { SeverErrorIllustration } from "assets";
import { useTranslation } from "react-i18next";
import { SUPPORT_CENTER_PHONE_NUMBER, SUPPORT_CENTER_PHONE_NUMBER_TEL_URL } from "logic/Consts";

export function BulkMessageDialogTrialEndedBanner(): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Stack sx={{ maxWidth: 480, margin: "auto", mt: 3, textAlign: "center" }}>
      <Typography variant="h3" paragraph>
        {translate("contactsPage.bulkMessage.trialEnded.title")}
      </Typography>
      <Typography sx={{ color: "text.secondary" }}>
        {translate("contactsPage.bulkMessage.trialEnded.description")}
      </Typography>
      <Button
        sx={{ mt: 2 }}
        size="large"
        href={SUPPORT_CENTER_PHONE_NUMBER_TEL_URL}
        target="_blank"
        variant="contained"
      >
        {translate("contactsPage.bulkMessage.trialEnded.salesRepresentative", {
          supportPhoneNumber: SUPPORT_CENTER_PHONE_NUMBER
        })}
      </Button>
      <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
    </Stack>
  );
}
